<div class="spb-holder">
  <spb-header/>
  <div class="spb-plain-content">
    <router-outlet/>
  </div>
  <div class="spb-filler"></div>
  <spb-footer
    copyrightYears="2023"
    [license]="true" [version]="version"/>
</div>
